import React, { Component } from 'react';
import { Image } from 'semantic-ui-react';

/**
 * @typedef {{
 *  src: string,
 *  style?: React.CSSProperties,
 *  text: string,
 * }} Props
 * @extends {Component<Props>}
 */
export default class Avatar extends React.Component {
  render() {
    const {
      src, style, text
    } = this.props;

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <Image
          {...this.props}
          src={src}
          style={{ ...(style || {}) }}
          onError={() => this.setState({ urlError: true })}
        />
        <div style={{ width: '100%', textAlign: 'center', fontSize: '16px', margin: '40px 0px', color: '#6C6C6C' }}>{text}</div>
      </div>
    );
  }
}
